import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toggleOrderedList as toggleOrderedListKeymap, formatShortcut } from '@atlaskit/editor-common/keymaps';
import { listMessages } from '@atlaskit/editor-common/messages';
import { getInputMethodFromParentKeys } from '@atlaskit/editor-common/toolbar';
import { ListNumberedIcon, ToolbarDropdownItem, ToolbarKeyboardShortcutHint } from '@atlaskit/editor-toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
export var NumberedListMenuItem = function NumberedListMenuItem(_ref) {
  var api = _ref.api,
    parents = _ref.parents;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var isTaskListItemEnabled = expValEquals('platform_editor_toolbar_task_list_menu_item', 'isEnabled', true);
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['list', 'taskDecision'], function (states) {
      var _states$listState, _states$listState2, _states$taskDecisionS;
      return {
        orderedListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.orderedListActive,
        orderedListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.orderedListDisabled,
        taskListActive: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
      };
    }),
    orderedListActive = _useSharedPluginState.orderedListActive,
    orderedListDisabled = _useSharedPluginState.orderedListDisabled,
    taskListActive = _useSharedPluginState.taskListActive;
  var onClick = function onClick() {
    var _api$taskDecision;
    api === null || api === void 0 || api.core.actions.execute(isTaskListItemEnabled && taskListActive ? api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 ? void 0 : _api$taskDecision.commands.toggleTaskList('orderedList') : api === null || api === void 0 ? void 0 : api.list.commands.toggleOrderedList(getInputMethodFromParentKeys(parents)));
  };
  var shortcut = formatShortcut(toggleOrderedListKeymap);
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(ListNumberedIcon, {
      size: "small",
      label: ""
    }),
    elemAfter: shortcut ? /*#__PURE__*/React.createElement(ToolbarKeyboardShortcutHint, {
      shortcut: shortcut
    }) : undefined,
    isSelected: orderedListActive,
    isDisabled: isTaskListItemEnabled ? orderedListDisabled && !taskListActive : orderedListDisabled,
    onClick: onClick,
    ariaKeyshortcuts: shortcut
  }, formatMessage(listMessages.orderedList));
};